import { Box } from '@dbi-tools/ui-kit';
import IconScroll from '@dbi-tools/ui-kit/lib/icons/scroll';
import React from 'react';

const QuestionSubText: React.FC<{ text?: string; scrollingIcon?: boolean }> = ({ text, scrollingIcon = false }) => {
  if (text) {
    text = text.replace(/\*(.*?)\*/g, '<b>$1</b>');
  }

  let content = <div dangerouslySetInnerHTML={{ __html: text }} />;
  if (scrollingIcon) {
    content = (
      <Box alignItems="center" display="flex">
        <IconScroll color="gray500" measure={50} mr={10} />
        {content}
      </Box>
    );
  }
  return text && content;
};

export default QuestionSubText;
